module.exports = __webpack_public_path__ + "16bde075d16662e8bff7eee0d1771db3.svg";